import React, { useEffect } from "react";
import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";
import { MODULES_LIST } from "@/util/common_variable";

const QuickSearchBookings = ({ path }) => {
  useEffect(() => {
    console.log(path);
  }, [path]);

  return (
    <>
      {/* ═══════════════════════════════════════════════════════════════
          BOOKINGS
      ════════════════════════════════════════════════════════════════ */}
      {path === MODULES_LIST.BOOKINGS && (
        <>
          <StyledSectionHeading>
            <span>Booking Information</span>
          </StyledSectionHeading>
          <StyledGridRow gutter={16}>
            <StyledGridCol>
              <FormItem name="arrestDate" label="Arrest Date">
                <CommonDatePicker
                  showTime={false}
                  format="MM/DD/YYYY"
                  style={{ maxWidth: "130px" }}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="jacketId" label="Folder ID">
                <TextField style={{ maxWidth: "120px" }} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="custodyStatus" label="Custody Status">
                <Select
                  options={[
                    { value: "In Custody", label: "In Custody" },
                    { value: "Scheduled", label: "Scheduled" },
                    { value: "Released", label: "Released" },
                  ]}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="incarcerationDate" label="Incarceration Date">
                <CommonDatePicker showTime={false} format="MM/DD/YYYY" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem
                name="justBookingsForAgency"
                label="Just Bookings for agency?"
                valuePropName="checked"
              >
                <Checkbox />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </>
      )}

      {/* ═══════════════════════════════════════════════════════════════
          WARRANTS
      ════════════════════════════════════════════════════════════════ */}
      {path === MODULES_LIST.WARRANTS && (
        <>
          {/* ── Biographical Information ── */}
          <StyledSectionHeading>
            <span>Biographical Information</span>
          </StyledSectionHeading>
          <StyledGridRow gutter={16}>
            <StyledGridCol>
              <FormItem name="lastName" label="Last Name">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="firstName" label="First Name">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="middleName" label="Middle Name">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="dob" label="DOB">
                <CommonDatePicker format="MM/DD/YYYY" showTime={false} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="ssn" label="SSN">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="fbi" label="FBI">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="sid" label="SID">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="jacketId" label="Folder ID">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="chn" label="CHN">
                <TextField />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>

          {/* ── Warrant Information ── */}
          <StyledSectionHeading>
            <span>Warrant Information</span>
          </StyledSectionHeading>
          <StyledGridRow gutter={16}>
            <StyledGridCol>
              <FormItem name="warrantNumber" label="Warrant Number">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="caseNumber" label="Case Number">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="courtNumber" label="Court #">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="statusID" label="Status">
                <Select options={getOptionsFromRefList("Status", false, false, true)} />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>

          {/* ── Offense Information ── */}
          <StyledSectionHeading>
            <span>Offense Information</span>
          </StyledSectionHeading>
          <StyledGridRow gutter={16}>
            <StyledGridCol>
              <FormItem name="charge" label="Charge">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="warrantType" label="Type">
                <Select options={getOptionsFromRefList("WarrantType")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol style={{ display: "flex", alignItems: "center" }}>
              <FormItem
                name="requiresReview"
                valuePropName="checked"
                style={{ marginBottom: 0 }}
              >
                <Checkbox>Requires review?</Checkbox>
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </>
      )}

      {/* ═══════════════════════════════════════════════════════════════
          SECTION HEADING — shared by BOOKINGS, STAFF, LINEUPS
          (not shown for WARRANTS — it has its own heading above)
      ════════════════════════════════════════════════════════════════ */}
      {path !== MODULES_LIST.LINEUPS && path !== MODULES_LIST.WARRANTS && (
        <StyledSectionHeading>
          <span>
            {path === MODULES_LIST.STAFF
              ? "Staff Information"
              : "Biographical Information"}
          </span>
        </StyledSectionHeading>
      )}

      {/* ═══════════════════════════════════════════════════════════════
          BIOGRAPHICAL FIELDS — shared by BOOKINGS & LINEUPS
          (WARRANTS has its own biographical block above)
      ════════════════════════════════════════════════════════════════ */}
      <StyledGridRow gutter={16}>
        {path !== MODULES_LIST.LINEUPS && path !== MODULES_LIST.WARRANTS && (
          <>
            <StyledGridCol>
              <FormItem name="lName" label="Last Name">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="fName" label="First Name">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="mName" label="Middle Name">
                <TextField />
              </FormItem>
            </StyledGridCol>
          </>
        )}

        {(path === MODULES_LIST.BOOKINGS || path === MODULES_LIST.LINEUPS) && (
          <>
            {path === MODULES_LIST.BOOKINGS && (
              <>
                <StyledGridCol>
                  <FormItem name="dob" label="DOB">
                    <CommonDatePicker format="MM/DD/YYYY" showTime={false} />
                  </FormItem>
                </StyledGridCol>
                <StyledGridCol>
                  <FormItem name="ssn" label="Social Security Number">
                    <TextField />
                  </FormItem>
                </StyledGridCol>
                <StyledGridCol>
                  <FormItem name="dlNumber" label="Driver's License">
                    <TextField />
                  </FormItem>
                </StyledGridCol>
                <StyledGridCol>
                  <FormItem name="pinNo" label="PIN">
                    <TextField />
                  </FormItem>
                </StyledGridCol>
                <StyledGridCol>
                  <FormItem name="sid" label="SID">
                    <TextField />
                  </FormItem>
                </StyledGridCol>
                <StyledGridCol>
                  <FormItem name="aliases" label="Alias">
                    <TextField />
                  </FormItem>
                </StyledGridCol>
              </>
            )}

            <StyledGridCol>
              <FormItem name="race" label="Race">
                <Select options={getOptionsFromRefList("Race")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="gender" label="Gender">
                <Select options={getOptionsFromRefList("Gender")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem label="Height +/-">
                <StyledFlex>
                  <FormItem name="height" noStyle>
                    <TextField style={{ maxWidth: "110px" }} type="number" />
                  </FormItem>
                  <FormItem name="heightPlusOrMinus" noStyle>
                    <TextField style={{ maxWidth: "75px" }} type="number" />
                  </FormItem>
                </StyledFlex>
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem label="Weight +/-">
                <StyledFlex>
                  <FormItem name="weight" noStyle>
                    <TextField style={{ maxWidth: "110px" }} type="number" />
                  </FormItem>
                  <FormItem name="weightPlusOrMinus" noStyle>
                    <TextField style={{ maxWidth: "75px" }} type="number" />
                  </FormItem>
                </StyledFlex>
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem label="Age +/-">
                <StyledFlex>
                  <FormItem name="ageAtEntry" noStyle>
                    <TextField style={{ maxWidth: "110px" }} type="number" />
                  </FormItem>
                  <FormItem name="agePlusOrMinus" noStyle>
                    <TextField style={{ maxWidth: "75px" }} type="number" />
                  </FormItem>
                </StyledFlex>
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="hair" label="Hair">
                <Select options={getOptionsFromRefList("hair")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="eyes" label="Eyes">
                <Select options={getOptionsFromRefList("eyes")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="glasses" label="Glasses">
                <Select options={getOptionsFromRefList("glasses", false, true)} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="hairLength" label="H Length">
                <Select options={getOptionsFromRefList("hair_Length")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="facialHair" label="Face H.">
                <Select options={getOptionsFromRefList("facial_Hair")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="complexion" label="Complexion">
                <Select options={getOptionsFromRefList("complexion")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="ethnicity" label="Ethnicity">
                <Select options={getOptionsFromRefList("ethnicity")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem
                name="imageType"
                label="Image Type"
                rules={
                  path === MODULES_LIST.LINEUPS
                    ? [{ required: true }]
                    : []
                }
              >
                <Select options={getOptionsFromRefList("Image_Type")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="juvenile" label="Juveniles">
                <Select options={getOptionsFromRefList("BioQuickSearchJuveniles")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="characteristicType" label="Dist. Char. Type">
                <Select
                  options={getOptionsFromRefList("DistinguishingCharacteristics")}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="description" label="Dist. Char. Description">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="characteristicLocation" label="Location">
                <Select options={getOptionsFromRefList("CharacteristicLocation")} />
              </FormItem>
            </StyledGridCol>
          </>
        )}
      </StyledGridRow>

      {/* ═══════════════════════════════════════════════════════════════
          STAFF-SPECIFIC FIELDS
      ════════════════════════════════════════════════════════════════ */}
      <StyledGridRow gutter={16}>
        {path === MODULES_LIST.STAFF && (
          <>
            <StyledGridCol lg={6}>
              <FormItem name="rank" label="Rank">
                <Select options={getOptionsFromRefList("Rank")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem name="division" label="Division">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem name="badge" label="Badge Number">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem name="username" label="User Name">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6} style={{ display: "flex", alignItems: "center" }}>
              <FormItem
                name="isActive"
                valuePropName="checked"
                style={{ marginBottom: 0 }}
              >
                <Checkbox>Inactive</Checkbox>
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem name="agency" label="Agency">
                <Select options={getOptionsFromRefList("Housing_Agency")} />
              </FormItem>
            </StyledGridCol>
          </>
        )}
      </StyledGridRow>
    </>
  );
};

export default QuickSearchBookings;
